import { defineMessages } from 'react-intl'

const messages = {
  track: defineMessages({
    title: {
      id: 'landingPage.features.trackEverything.title',
      defaultMessage: 'Track Everything',
    },
    description: {
      id: 'landingPage.features.trackEverything.description',
      defaultMessage: 'Log any kind of workout using just your phone or with your favorite device like Garmin or Apple Watch.',
    },
  }),
  social: defineMessages({
    title: {
      id: 'landingPage.features.getSocial.title',
      defaultMessage: 'Get Social',
    },
    description: {
      id: 'landingPage.features.getSocial.description',
      defaultMessage: 'Find support and motivation from other runners, plus create challenges for you and your friends.',
    },
  }),
  train: defineMessages({
    title: {
      id: 'landingPage.features.trainSmarter.title',
      defaultMessage: 'Train Smarter',
    },
    description: {
      id: 'landingPage.features.trainSmarter.description',
      defaultMessage: 'Analyze your data in the app or on the web, then conquer that 5K or marathon using our adaptive training plans.',
    },
  }),
}

export default messages



// WEBPACK FOOTER //
// ./src/components/landing/features/messages.js